module.exports = __webpack_public_path__ + "img/ic-media-hover.ae275f73.svg";